module.exports = __webpack_public_path__ + "assets/can_be_better.250e425e0e02b1375d94af055d2471d1c9793537125b94ad0ad8927022707d16.png";